import { defineMessages } from 'react-intl';

export const messages: {
	loadErrorMessage: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	loadErrorTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	loadErrorTitle: {
		id: 'navigation.ribbon.navigation-ribbon.org-switcher.load-error.title',
		description: 'Title shown in the org switcher component when the apps data failed to load',
		defaultMessage: 'We couldn’t load the organization switcher',
	},
	loadErrorMessage: {
		id: 'navigation.ribbon.navigation-ribbon.org-switcher.load-error.message',
		description: 'Message shown in the org switcher component when the apps data failed to load',
		defaultMessage: 'Refresh the page and try again',
	},
});
